import { defineStore } from 'pinia'
import { ref } from 'vue'
import { deleteHistoryDownloadPath as  deleteHistoryDownloadPathAPI, fetchHistoryDownloadPath } from '@remote/api/device'
import { toast } from '@remote/utils'
import { getDir } from '@remote/api/files'
import { store } from '@remote/store'

/**
 * 创建、获取、删除、缓存 下载历史记录
 */
const useDownloadHistory = () => {
  const historyDownloadPath = ref<API_DEVICE.HistoryDownloadPath[]>([])

  const getHistoryDownloadPath = async () => {
    historyDownloadPath.value = await fetchHistoryDownloadPath()
  }

  const deleteHistoryDownloadPath = async (id: string) => {
    await deleteHistoryDownloadPathAPI(id)
    historyDownloadPath.value = historyDownloadPath.value.filter(i => i.Id !== id)
    toast('删除历史记录成功')
  }

  return {
    historyDownloadPath,
    getHistoryDownloadPath,
    deleteHistoryDownloadPath,
  }
}

/**
 * 获取、访问根目录
 * 因为现在watch接口的downloads字段没有返回fileID，所以要提前获取一下根路径下有哪些文件夹。
 * 红宝说后面可能会在watch接口的downloads字段返回fileID
 */
const useRootDirectory = () => {
  const rootDirectory = ref<API_FILE.DriveFile[]>([])

  const refreshRootDirectory = async () => {
    const res = await getDir(store.state.deviceInfoWatchData.target ?? '')
    rootDirectory.value = res?.files ?? []
  }

  return {
    rootDirectory,
    refreshRootDirectory,
  }
}

/**
 * 下载相关的状态
 * Vuex store 的 index 模块，慢慢拆分出下载相关的状态，慢慢往这边转。
 */
export const useDownloadStore = defineStore('download', () => {
  const {
    historyDownloadPath,
    getHistoryDownloadPath,
    deleteHistoryDownloadPath,
  } = useDownloadHistory() 

  const {
    rootDirectory,
    refreshRootDirectory,
  } = useRootDirectory()

  return {
    // 历史记录
    historyDownloadPath,
    getHistoryDownloadPath,
    deleteHistoryDownloadPath,
    // 根目录
    rootDirectory,
    refreshRootDirectory,
  }
})